window.addEventListener('load', function() {
  try {

      console.log("Bubblee Detected");
      const header_container = document.querySelector('.header__bubbles');
      const footer_container = document.querySelector('.footer__bubbles');
      
      for (let i = 0; i < 128; i++) {
          const header_bubble = document.createElement('div');
          const footer_bubble = document.createElement('div');

          header_bubble.className = 'bubble';
          footer_bubble.className = 'bubble';
        
          const header_size = 2 + Math.random() * 4;
          const footer_size = 2 + Math.random() * 4;
          const header_distance = 6 + Math.random() * 4;
          const footer_distance = 6 + Math.random() * 4;
          const header_position = -5 + Math.random() * 110;
          const footer_position = -5 + Math.random() * 110;
          const header_time = 2 + Math.random() * 2;
          const footer_time = 2 + Math.random() * 2;
          const header_delay = -(2 + Math.random() * 2);
          const footer_delay = -(2 + Math.random() * 2);

          header_bubble.style.cssText = `
              --size: ${header_size}rem;
              --distance: ${header_distance}rem;
              --position: ${header_position}%;
              --time: ${header_time}s;
              --delay: ${header_delay}s;
          `;
        
          footer_bubble.style.cssText = `
              --size: ${footer_size}rem;
              --distance: ${footer_distance}rem;
              --position: ${footer_position}%;
              --time: ${footer_time}s;
              --delay: ${footer_delay}s;
          `;

          header_container.appendChild(header_bubble);
          footer_container.appendChild(footer_bubble);
        
      }
  
  } catch (error) {
    console.error(error);
  }
  
});